module.exports = __webpack_public_path__ + "static/media/influencerpreview.7a6ef3b3.png";